const loadCode = {

	/**
	 * Modal.
	 *
	 * @type {object}
	 */
	modal: null,


	/**
	 * List of code items to display.
	 *
	 * @type {array}
	 */
	items: [],


	/**
	 * A link to the function that should be called when the code is loaded.
	 *
	 * @type {function}
	 */
	setCode: null,


	/**
	 * The folder for the thumbnail assets.
	 *
	 * @type {string}
	 */
	assetPrefix: '',


	/**
	 * Display the code picker.
	 *
	 * @return {void}
	 */
	show: function() {

		loadCode.modal = modal.showGeneral( 'Load Code' );
		loadCode.modal.innerHTML = loadCode.template();

		loadCode.modal.addEventListener(
			'click',
			loadCode.click
		);

		[ 'dragenter', 'dragover', 'dragleave', 'drop' ].forEach(
			eventName => {
				loadCode.modal.addEventListener(
					eventName,
					( e ) => {
						e.preventDefault();
						e.stopPropagation();
					},
					false
				);
			}
		);

		loadCode.modal.addEventListener( 'change', loadCode.change );
		loadCode.modal.addEventListener( 'drop', loadCode.dropEvent );

	},


	/**
	 * Change event for file input.
	 *
	 * @param {event} e The change event.
	 * @return {void}
	 */
	change: function( e ) {

		loadCode.loadFile( e.target.files[ 0 ] );

	},


	/**
	 * Drop event for file input.
	 *
	 * @param {event} e The drop event.
	 * @return {void}
	 */
	dropEvent: function( e ) {

		e.preventDefault();

		loadCode.loadFile( e.dataTransfer.files[ 0 ] );

	},


	/**
	 * Load a text file.
	 *
	 * @param {string} file The file contents.
	 * @return {void}
	 */
	loadFile: function( file ) {

		const reader = new FileReader();

		reader.onload = function( e ) {
			loadCode.load( e.target.result );
		};

		reader.readAsText( file );

	},


	/**
	 * Display list of code files that can be loaded.
	 *
	 * @return {string}
	 */
	template: function() {

		let template = '';

		Object.keys( loadCode.items ).forEach(
			( key ) => {
				let item = loadCode.items[ key ];
				let title = item.title;
				if ( item.premium ) {
					title = `${ninja_props.icon_premium} ${title}`;
				}
				template += `<button class="thumbnail thumbnail-fullwidth-image" data-key="${key}">
					<img
						src="/assets/images-code-examples/${loadCode.assetPrefix}/${urlString( key )}.png"
						loading="lazy"
						alt="*"
					/>
					<span class="credit">${title}</span>
				</button>`;
			}
		);

		template = `
			${loadCode.loadFileTemplate()}
			<h2 class="m-b2">Examples</h2>
			<p>Click on an example to load it into the editor.</p>
			<div class="button-grid">${template}</div>
		`;

		return template + loadCode.upsell();

	},


	/**
	 * Load a code ninja file.
	 *
	 * @return {string}
	 */
	loadFileTemplate: function() {

		let html = '';

		html += `
		<label for="file-uploader" class="file-upload">
			Choose a Code Ninja File
			<input type="file" id="file-uploader" accept=".codeninja" />
		</label>
		`;

		return html;

	},


	/**
	 * The template for signed out users with a prompt to join.
	 *
	 * @return {string}
	 */
	templatePremium: function() {

		let template = `<div class="premium">${ninja_props.icon_premium} This example is for members only. <a href="/join/">Join Brush Ninja Members</a> for access to all of the Code Ninja samples, plus lots more.</div>`;
		template += `<button class="loadCode-other button">&larr; Load Different Example</button>`;

		return template;

	},


	/**
	 * Display upgrade message.
	 *
	 * @return {string}
	 */
	upsell: function() {

		let template = '';

		// If not a member.
		if ( !members.isSubscriber() ) {
			template = `<div class=""></div>`;
		}

		return template;

	},


	/**
	 * Click event for items.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	click: function( e ) {

		const key = e.target.getAttribute( 'data-key' );

		if ( key ) {

			e.preventDefault();

			const item = loadCode.items[ key ];

			if ( item.premium & !members.isSubscriber() ) {
				loadCode.modal.innerHTML = loadCode.templatePremium();
				return;
			}

			if ( item && loadCode.setCode ) {
				loadCode.load( loadCode.items[ key ].content );
				return;
			}

		}

		// Revert to the normal template after displaying the upsell screen.
		if ( e.target.classList.contains( 'loadCode-other' ) ) {

			e.preventDefault();
			loadCode.modal.innerHTML = loadCode.template();

		}

	},


	/**
	 * Load the code and reset the modal.
	 *
	 * @param {string} code The code to load.
	 * @return {void}
	 */
	load: function( code ) {

		modal.reset();
		loadCode.setCode( code.trim() );
		ninjaEvent( 'load-code-loaded' )

	},

};